'use strict';

import { CoreRepository } from '../CoreRepository';
import type { UserLeadStatusNames } from '../../Entities/User/UserLeadStatus';
import { UserLeadStatus } from '../../Entities/User/UserLeadStatus';
import { UserLeadStatusCollection } from '../../Collections/User/UserLeadStatusCollection';

export class UserLeadStatusRepository extends CoreRepository {
  /*public getUserLeadStatuses(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserLeadsStatuses(userId, options)
      .then(response => {
        let collection = new UserLeadStatusCollection();

        response.data.forEach(collectionItemData => {
          let collectionItem = new UserLeadStatus();
          collectionItem.hydrate(collectionItemData);

          collection.addItem(collectionItem);
        });

        collection.setOffset(response.offset);
        collection.setLimit(response.limit);
        collection.setTotal(response.total);

        return collection;
      });

  }*/

  public getUserLeadStatuses(userId: number, options: object = {}, criteria: object = null) {
    return this.webAPI.getUserLeadsStatuses(userId).then((response) => {
      const collection: UserLeadStatusNames[] = [];

      response.forEach((userLeadStatusNames: UserLeadStatusNames) => {
        collection.push(userLeadStatusNames);
      });

      return collection;
    });
  }

  public getUserLeadsStatusesDeconstructed(
    userId: number,
    options: object = {},
    criteria: object = null
  ) {
    return this.webAPI.getUserLeadsStatuses(userId).then((response) => {
      const collection: UserLeadStatusNames[] = [];

      response.data.forEach((items) => {
        items.items.forEach((userLeadStatusNames: UserLeadStatusNames) => {
          collection.push(userLeadStatusNames);
        });
      });

      return collection;
    });
  }
}
